import type { FaireProductEntity } from "../../entity_types/product";

export const p_82dc8c3czb: FaireProductEntity = {
  token: "p_82dc8c3czb",
  type: "product",
  name: "Latte Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/319a1fdcc0ac221e4f92919503fbd4042629107c0bf0ff5cc0a1d481f58b27c2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa02cd91e0a2b0eae24294f1daae8461f6a479159122820ba786eb765e8dc7a1.jpeg",
    "https://cdn.faire.com/fastly/5e3b4df7876c6ca79d1677d30637c5079f58c3ed43495c09a0b2a862944f46f1.jpeg",
    "https://cdn.faire.com/fastly/d6a9b20d642142d1fa88fbd5a0011fc0565f896be5e664dffdd62bac03d734f4.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:53.411Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
